import React from 'react';
import styles from "../../styles/portfolio/project_brief.scss";


export const ProjectBrief = props => {
    return (
        <div className={props.className}>
            <div className={styles.titleContainer}>
                {<props.IconComp className={styles.icon}/>}
                <div className={styles.title}>{props.title}</div>
            </div>
            {props.DescriptionCompInstance}
            <div className={styles.techContainer}>
                {props.iconComponentList?.map((value) => {
                    return value;
                })}
            </div>
            <div className={styles.techContainer}>
                {props.optionComponents?.map((value) => {
                    return value;
                })}
            </div>

        </div>
    )
};
